import { createContext, useContext, useEffect, useState } from "react";
import UserSessionService from "@/lib/UserSessionService";
import { UserTypes } from "@/configs/AppConfig";
import { MOD_AUTH } from "@/configs/ModulesConfig";
import api from "@/api/api";

// import { useNavigate } from "react-router-dom";
// import { useLayout } from "./LayoutProvider";

const SessionContext = createContext(null);

const SessionProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userType, setUserType] = useState(null);
  const [rights, setRights] = useState([]);

  useEffect(() => {
    const loginData = {
      user: UserSessionService.getUser(),
      userType: UserSessionService.getUserType(),
      rights: UserSessionService.getRights(),
    };
    const key = UserSessionService.getUserKeyObj();
    if (
      (loginData.userType == UserTypes.PATIENT ||
        loginData.userType == UserTypes.SYSTEM_USER) &&
      !!key
    ) {
      setIsAuthenticated(true);
      setUser(loginData.user);
      setUserType(loginData.userType);
      setRights(loginData.rights);
    } else {
      setIsAuthenticated(false);
      setUser(null);
      setUserType(UserTypes.GUEST);
      setRights([]);
      UserSessionService.removeSession();
    }
  }, [isAuthenticated]);

  async function login(payload) {
    const response = await api.post(MOD_AUTH.api.auth, payload);
    const badRequest = response.status !== 201;
    const statusCode = response?.data?.status;
    const message = response?.data?.message;

    if (message && statusCode < 0) {
      throw {
        message: message,
      };
    }
    if (badRequest) {
      throw {
        message: message || "Log in failed",
      };
    } 
    const data = {
      user: {
        name: response.data.userFullName,
        email: response.data.email,
        mobileNo: response.data.mobileNo,
        birthDate: response.data.birthDate,
        patientId: response.data.patientId,
        gender: response.data.gender,
        isSelfRegistered: response.data.isSelfRegistered,
        profileCount: response.data.profileCount,
      },
      userKey: response.data.userKey,
    };
    UserSessionService.setSession(
      UserTypes.PATIENT,
      data.user,
      data.userKey,
      [],
    );
    setIsAuthenticated(true);
    return data;
  }
  async function register(payload) {
    const response = await api.post(MOD_AUTH.api.register, payload);
    const badRequest = response.status !== 201;
    const statusCode = response?.data?.status;
    const message = response?.data?.message;

    if (message && statusCode < 0) {
      throw {
        message: message,
      };
    }
    if (badRequest) {
      throw {
        message: message || "Registration failed",
      };
    } 
    return response.data;
  } 
  async function logout() {
    const api_url = MOD_AUTH.api.logout;
    await api
      .post(api_url)
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        UserSessionService.removeSession();
        setIsAuthenticated(false);
      });
  }

  function updateRights(rights, error = false) {
    if (error) {
      logout();
      return;
    }
    setRights(rights);
    UserSessionService.setRights(rights);
  }

  return (
    <SessionContext.Provider
      value={{
        user,
        isAuthenticated,
        userType,
        rights,
        login,
        register, 
        logout,
        updateRights,
      }}
    >
      {children}
    </SessionContext.Provider>
  );
};

export default SessionProvider;

export const useSession = () => useContext(SessionContext);
